import { dataHeartSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconHeartSolid = /*#__PURE__*/createIcon(dataHeartSolid)
export default IconHeartSolid
